import { useLazyQuery, useMutation } from "@apollo/client";
import prepareComponent from "@bluframe/grapple/prepareComponent";
import { mutations, queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import { useHistory } from "react-router-dom";
import Add from "./Add";
const { forum: { GET_SECTIONS } } = queries;
const { forum: { ADD_SECTION } } = mutations;
const DEFAULT_ORDER = 0;
const usePrepareComponent = () => {
    const history = useHistory();
    const [addContent, { loading }] = useMutation(ADD_SECTION, {
        refetchQueries: [GET_SECTIONS]
    });
    const [getContents] = useLazyQuery(GET_SECTIONS);
    const onCancel = () => {
        history.push("/forum/sections");
    };
    const onSave = (itemAdd) => {
        addContent({
            onCompleted: () => {
                getContents({
                    fetchPolicy: "network-only",
                    onCompleted: () => {
                        history.push("/forum/sections");
                    }
                });
            },
            variables: {
                section: {
                    ...itemAdd,
                    description: itemAdd.description ?? "",
                    name: itemAdd.name ?? "",
                    order: itemAdd.order ?? DEFAULT_ORDER
                }
            }
        });
    };
    return {
        loading,
        onCancel,
        onSave
    };
};
export default prepareComponent(usePrepareComponent)(Add);
